import React, { useState } from "react";
import {Grid, Tabs, Tab, Box, InputAdornment, Paper} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button  from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search'
import Folders from './configuration/Folders';
import StorageIcon from '@material-ui/icons/Storage';
import SettingsIcon from '@material-ui/icons/Settings';
import DescriptionIcon from '@material-ui/icons/Description';
import { makeStyles } from '@material-ui/core/styles';

import { useHistory } from "react-router-dom";
import color from "@material-ui/core/colors/amber";


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    overflow: 'auto'
  },


  container: {
    display: 'flex',
    alignItems: 'center',
    padding: 2,
    marginTop: '30px' 
  },

  title:{
    fontFamily: '"Montserrat", sans-serif !important',
    fontWeight: '700 !important',
    fontSize: '32px',
  },

  paper:{
    width: 200,
    height: 140,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight:'12px' ,
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
      transform: 'translateY(-2px)',
    },
  },






  icon:{
    fontSize: '48px',
    width: '48px',
    height: '48px',
  },

  paperLabel:{
    fontFamily: '"Montserrat", sans-serif !important',
    fontWeight: '400 !important',
    fontSize: '14px',
    lineHeight: '21px'
  }

}));

export default function Configurations() {
 
  const classes = useStyles();

  const features = {
    'storage': '/document-suite/configurations/storage'
  }

  const history = useHistory();

  const handleIconClick = (feature) => () => {
    if (features[feature]) {
      history.push(features[feature]);
    }
  };
  
  return (
    <div className={classes.root}>
        <Typography 
          className={classes.title}
        >
          CONFIGURATIONS
        </Typography>

        <div className={classes.container}>
           
            <Paper  className={classes.paper} onClick={handleIconClick('storage')}>
                <StorageIcon className={classes.icon}></StorageIcon>
                <Typography className={classes.paperLabel}>
                    Storage
                </Typography>
            </Paper>


            <Paper  className={classes.paper} onClick={handleIconClick('integration')}>
                <SettingsIcon className={classes.icon}></SettingsIcon>
                <Typography className={classes.paperLabel}>
                    Integration
                </Typography>
            </Paper>

            <Paper  className={classes.paper} onClick={handleIconClick('document processing')}>
                <DescriptionIcon className={classes.icon}></DescriptionIcon>
                <Typography className={classes.paperLabel}>
                    Document Processing
                </Typography>
            </Paper>

        </div>

     
    </div>
  );
}
